/*
    TODO: We won't move this service to angular because it is look like workaround
     to solve problem with state sharing.
     PhoneData is located at MeetingStateService.ts
 */
firebird.factory('phoneConferenceService', [
    'logService',
    function (logService) {
        const logger = logService.createLoggerWithSource('phoneConferenceService');

        return {
            init: init,
            getPhoneData: getPhoneData
        };

        ////////////////////////

        function init(data) {
            logger.log('setting phoneConferenceService data to: ', data);
            this.phoneData = data;
        }

        function getPhoneData() {
            return this.phoneData;
        }
    }
]);
